function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component, createRef } from 'react';
import _ from 'underscore';

/**
 * SearchButton widget.
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var SearchButton = /*#__PURE__*/function (_Component) {
  function SearchButton(props) {
    var _this;
    _classCallCheck(this, SearchButton);
    _this = _callSuper(this, SearchButton, [props]);
    _defineProperty(_this, "toggleDropdownVisibility", function () {
      _this.setState(function (prevState) {
        return {
          dropdownVisible: !prevState.dropdownVisible
        };
      });
    });
    _this.state = {
      methods: [],
      hasQuery: false,
      hasDatabases: false,
      dropdownVisible: false,
      messageTooltip: "",
      titleTooltip: "",
      hideMessageTooltip: false
    };
    _this.changeAlgorithm = _this.changeAlgorithm.bind(_this);
    _this.decorate = _this.decorate.bind(_this);
    _this.setMessageTooltipButton = _this.setMessageTooltipButton.bind(_this);
    _this.setTitleTooltipButton = _this.setTitleTooltipButton.bind(_this);
    _this.renderButton = _this.renderButton.bind(_this);
    _this.inputGroup = _this.inputGroup.bind(_this);
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handeMouseOut = _this.handeMouseOut.bind(_this);
    _this.inputGroupRef = /*#__PURE__*/createRef();
    return _this;
  }
  _inherits(SearchButton, _Component);
  return _createClass(SearchButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.timeout = setTimeout(function () {
        return _this2.setState({
          hideMessageTooltip: true
        });
      }, 3000);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(props, state) {
      return !_.isEqual(state.methods, this.state.methods) || state.dropdownVisible !== this.state.dropdownVisible || state.messageTooltip !== this.state.messageTooltip || state.titleTooltip !== this.state.titleTooltip || state.hideMessageTooltip !== this.state.hideMessageTooltip;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (!_.isEqual(prevState.methods, this.state.methods)) {
        if (this.state.methods.length > 0) {
          this.inputGroup().wiggle();
          this.props.onAlgoChanged(this.state.methods[0]);
        } else {
          this.props.onAlgoChanged('');
        }
      }
    }
  }, {
    key: "inputGroup",
    value: function inputGroup() {
      return $(this.inputGroupRef.current);
    }

    /**
    * Change selected algorithm.
    *
    * NOTE: Called on click on dropdown menu items.
    */
  }, {
    key: "changeAlgorithm",
    value: function changeAlgorithm(method) {
      var methods = this.state.methods.slice();
      methods.splice(methods.indexOf(method), 1);
      methods.unshift(method);
      this.setState({
        methods: methods,
        dropdownVisible: false
      });
    }

    /**
    * Given, for example 'blastp', returns blast<strong>p</strong>.
    */
  }, {
    key: "decorate",
    value: function decorate(name) {
      return name.match(/(.?)(blast)(.?)/).slice(1).map(function (token, _) {
        if (token) {
          if (token !== 'blast') {
            return /*#__PURE__*/_jsx("strong", {
              children: token
            }, token);
          } else {
            return token;
          }
        }
      });
    }
  }, {
    key: "setMessageTooltipButton",
    value: function setMessageTooltipButton() {
      if (!this.state.hasQuery && !this.state.hasDatabases) {
        this.setState({
          messageTooltip: 'You must enter a query sequence and select one or more databases above before you can run a search!'
        });
      } else if (this.state.hasQuery && !this.state.hasDatabases) {
        this.setState({
          messageTooltip: 'You must select one or more databases above before you can run a search!'
        });
      } else if (!this.state.hasQuery && this.state.hasDatabases) {
        this.setState({
          messageTooltip: 'You must enter a query sequence above before you can run a search!'
        });
      }
    }
  }, {
    key: "setTitleTooltipButton",
    value: function setTitleTooltipButton() {
      var title = 'Click to BLAST or press Ctrl+Enter.';
      this.setState({
        titleTooltip: title
      });
      if (this.state.methods.length > 1) {
        this.setState({
          titleTooltip: title += ' Click dropdown button on the right for other' + ' BLAST algorithms that can be used.'
        });
      }
    }
  }, {
    key: "handeMouseOut",
    value: function handeMouseOut() {
      clearTimeout(this.timeout);
      this.setState({
        hideMessageTooltip: false
      });
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver() {
      var _this3 = this;
      this.setMessageTooltipButton();
      this.setTitleTooltipButton();
      this.timeout = setTimeout(function () {
        return _this3.setState({
          hideMessageTooltip: true
        });
      }, 3000);
    }
  }, {
    key: "renderButton",
    value: function renderButton(method, multi, methods) {
      return /*#__PURE__*/_jsxs("div", {
        className: "flex",
        children: [/*#__PURE__*/_jsx("button", {
          type: "submit",
          className: "".concat(method ? 'hover:bg-seqorange focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-seqorange ' : 'opacity-50 cursor-not-allowed ', "uppercase w-full md:w-auto flex text-xl justify-center py-2 px-16 border border-transparent rounded-md shadow-sm text-white bg-seqblue"),
          id: "method",
          name: "method",
          value: method,
          disabled: !method,
          children: this.decorate(method || 'blast')
        }), multi && /*#__PURE__*/_jsxs("div", {
          className: "ui--multi-dropdown",
          children: [/*#__PURE__*/_jsxs("button", {
            className: "text-xl bg-seqblue rounded-r-md text-white p-2 border border-seqblue hover:bg-seqorange focus:outline-none focus:ring-1 focus:ring-seqorange -ml-8",
            type: "button",
            onClick: this.toggleDropdownVisibility,
            children: [/*#__PURE__*/_jsx("i", {
              className: "fas fa-caret-down w-6 h-6 fill-current"
            }), /*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: "Other methods"
            })]
          }), /*#__PURE__*/_jsx("div", {
            id: "dropdown",
            className: "z-10 my-2 uppercase bg-blue-300 divide-y divide-gray-100 rounded-lg shadow absolute left-0 bottom-12 w-full text-xl text-center ".concat(this.state.dropdownVisible ? '' : 'hidden'),
            children: /*#__PURE__*/_jsx("ul", {
              className: "text-gray-700",
              "aria-labelledby": "dropdownDefaultButton",
              children: _.map(methods.slice(1), _.bind(function (method) {
                return /*#__PURE__*/_jsx("li", {
                  onClick: _.bind(function () {
                    this.changeAlgorithm(method);
                  }, this),
                  children: /*#__PURE__*/_jsx("a", {
                    href: "#",
                    className: "block px-4 py-2 hover:bg-blue-400 rounded-lg",
                    children: method
                  })
                }, method);
              }, this))
            })
          })]
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var methods = this.state.methods;
      var method = methods[0];
      var multi = methods.length > 1;
      return /*#__PURE__*/_jsx("div", {
        className: "my-4 md:my-2 flex justify-end w-full md:w-auto relative",
        id: "methods",
        ref: this.inputGroupRef,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handeMouseOut,
        children: /*#__PURE__*/_jsx("div", {
          className: "relative flex flex-col items-center group",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex items-center w-full",
            children: [this.renderButton(method, multi, methods), !this.state.dropdownVisible && /*#__PURE__*/_jsxs("div", {
              className: "absolute hidden bottom-11 items-center flex-col-reverse group-hover:flex w-full",
              children: [/*#__PURE__*/_jsx("div", {
                className: "w-0 h-0 border-y-8 border-r-8 border-t-transparent border-b-transparent border-r-black -mt-1 -mr-px tooltip-arrow-rotate"
              }), /*#__PURE__*/_jsx("span", {
                className: "relative z-10 p-2 search-button-text leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-md",
                children: !this.state.hasQuery || !this.state.hasDatabases ? this.state.hideMessageTooltip ? /*#__PURE__*/_jsx(_Fragment, {
                  children: this.state.titleTooltip
                }) : this.state.messageTooltip : /*#__PURE__*/_jsxs(_Fragment, {
                  children: [" ", this.state.titleTooltip]
                })
              })]
            })]
          })
        })
      });
    }
  }]);
}(Component);